define.alias("shared/components/shared/ui/past-post-limit-banner", "settings/components/shared/ui/past-post-limit-banner");